import { type FC } from 'react';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// common
import { LogoImage } from 'svg';
import {
  EXTREME_SMALL_FONT_SIZE,
  MEDIUM_FONT_SIZE,
  ORIGINAL_FONT_SIZE,
  SMALL_FONT_SIZE,
} from 'modules/map/components/pdf-print-form/utils';

interface PdfPrintTitleProps {
  title: string;
  subTitle: string;
  week: string;
}

const PdfPrintTitle: FC<PdfPrintTitleProps> = (props) => {
  const { title, subTitle, week } = props;

  return (
    <Box sx={{ fontSize: ORIGINAL_FONT_SIZE, height: '6vh' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            marginX: 4,
            alignSelf: 'flex-start',
            height: '100%',
          }}
        >
          <LogoImage style={{ height: 80, width: 80 }} />
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            height: '100%',
          }}
        >
          <Typography
            sx={{
              fontSize: EXTREME_SMALL_FONT_SIZE,
              fontWeight: 600,
              marginLeft: 12,
            }}
          >
            CÔNG TY TNHH HƯƠNG VIỆT SINH - ĐC: Lô BT1 - Ngõ 191 Phúc Lợi - P.Phúc Lợi - TP.Hà Nội
          </Typography>
          <Typography
            sx={{
              textAlign: 'center',
              fontSize: MEDIUM_FONT_SIZE,
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: SMALL_FONT_SIZE,
              fontStyle: 'italic',
              textAlign: 'center',
            }}
          >
            {subTitle}
          </Typography>
        </Box>
        <Box sx={{ height: '100%' }}>
          {week && (
            <Box
              sx={{
                padding: 2,
                border: '2px solid black',
                alignSelf: 'flex-start',
                fontSize: SMALL_FONT_SIZE,
                fontWeight: 600,
              }}
            >
              {week}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PdfPrintTitle;
